// extracted by mini-css-extract-plugin
export default {"container":"logo_container__fkYf5","logo":"logo_logo__NJQP6"};